export default __webpack_public_path__ + "static/media/utilities-not-selected.19f70224.svg";